import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const loginUser = (data)=>{
    return axios.post(`${API_BASE_URL}/users/login`, data);
}

export const refresh_token = ()=>{
    let token = localStorage.getItem('token');
    if(token){
        token = JSON.parse(token).token;
    }
    let headers = {
        Authorization: `Bearer ${token}`,
    }
    return axios.get(`${API_BASE_URL}/users/refresh-token`, { headers });
}